export { default as StrategyFilterSetDropdown } from './StrategyFilterSetDropdown';
